module.exports = __webpack_public_path__ + "media/images/company_logo/logo_ateam-e65f221dc408553a4e7b0f73b74bd5d8.jpg";